import React from 'react';
import PropTypes from 'prop-types';
import './Total.css';

const Total = ({ totalText }) => {

    return (
        <div className="properties-total">
            <p className="text">
                {!totalText ? '0 PROPERTIES / 0 SQ. FT.' : totalText}
            </p>
        </div>
    );
};

Total.propTypes = {
    totalText: PropTypes.string,
};

export default Total;
